module.exports = __webpack_public_path__ + "static/media/993795.711c3632.png";